<template>
  <svg viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M14.7012 12.277L17.8001 9.17795L14.7012 6.07898"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round" />
    <path
      d="M17.6232 9.17981H10.2641C7.46736 9.17981 5.2002 11.4469 5.2002 14.2428V16.9259"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round" />
  </svg>
</template>
